module.exports = __webpack_public_path__ + "img/delivery_1.f45fa7d8.png";